'use strict';

const StringPrompt = require('../types/string');

class InvisiblePrompt extends StringPrompt {
  format() {
    return '';
  }
}

module.exports = InvisiblePrompt;
